import {
	DELETE_BULK_PROGRESS,
	DELETE_PROGRESS,
	END_BULK_DELETE,
	END_DELETE,
	FILE_IS_DELETED,
	RELOAD_LIST,
	START_BULK_DELETE,
	START_DELETE,
} from "../types"

const initialState = {
	documents: {},
	isDeleting: false,
	bulk_delete: {
		deleting: false,
		percentage: 0,
	},
	selectedDocumentIds: {},
	isFileDeleted: false, //open the delete file info popup
	shouldReloadList: false, //Flag use to refresh/reload the list
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case START_DELETE:
			let auxDownloads = { ...state.documents }
			auxDownloads[action.payload] = { deleting: true, percentage: 0 }
			return {
				...state,
				documents: auxDownloads,
				isDeleting: true,
			}
		case END_DELETE:
			let auxDownloadsStop = { ...state.documents }
			auxDownloadsStop[action.payload] = { deleting: false, percentage: 0 }
			return {
				...state,
				documents: auxDownloadsStop,
				isDeleting: false,
			}
		case DELETE_PROGRESS:
			let auxDownloadProgress = state.documents
			auxDownloadProgress[action.payload.id].percentage = action.payload.percentage
			return {
				...state,
				documents: auxDownloadProgress,
			}
		case START_BULK_DELETE:
			let auxBulkDownloads = { ...state.bulk_delete }
			auxBulkDownloads = { deleting: true, percentage: 0 }
			return {
				...state,
				bulk_delete: auxBulkDownloads,
				isDeleting: true,
			}
		case END_BULK_DELETE:
			let auxBulkDownloadsStop = { ...state.bulk_delete }
			auxBulkDownloadsStop = { deleting: false, percentage: 0 }

			return {
				...state,
				bulk_delete: auxBulkDownloadsStop,
				isDeleting: false,
			}
		case DELETE_BULK_PROGRESS:
			let auxBulkDownloadProgress = state.bulk_delete
			auxDownloadProgress[action.payload.id].percentage = action.payload.percentage
			return {
				...state,
				documents: auxBulkDownloadProgress,
			}
		case FILE_IS_DELETED:
			return {
				...state,
				isFileDeleted: action.payload,
			}
		case RELOAD_LIST:
			return {
				...state,
				shouldReloadList: action.payload,
			}
		default:
			return state
	}
}
